import gql from 'graphql-tag';

export const VERIFY_HUBLY_FORM_FIELD_TYPE = gql`
  query VerifyHublyFormFieldType($input: VerifyHublyFormFieldTypeInput!) {
    verifyHublyFormFieldType(input: $input)
  }
`;

export type VerifyHublyFormFieldTypeInput = {
  input: {
    type: string;
    value: string;
  };
};

export type VerifyHublyFormFieldTypeResponse = {
  verifyHublyFormFieldType?: boolean;
};
